import { createContext } from "react";

export enum Roles {
  PwaDictAdmin = 'PWA_Administrator słowników SOPO',
  PwaAdmin = 'PWA_Administrator SOPO',
  PwaEditor = 'PWA_Edytor',
  PwaEditorExtended = 'PWA_Edytor rozszerzony',
  PwaVerificator = 'PWA_Weryfikator'
}

export type UserConfig = {
  rememberLogInDetails: boolean,
  automaticOnlineMode: boolean,
  checkForUpdates: {
      onOnlineToggle: boolean,
      onStartUp: boolean
  },
  notificationFrequency: NotificationFrequency,
  notificationTypeShown: NotificationTypeShown,
  tableSettings: TableSettings[]
}

export type TableSettings = {
  name: string,
  pageSize: number
}

export enum NotificationFrequency {
  Every5min,
  Every15min,
  EveryHour
}

export enum NotificationTypeShown {
  All,
  Unread,
  Last14Days
}

const AuthContext = createContext({
  authenticated: false,
  setAuthenticated: (auth: boolean) => {},
  user: '',
  setUser: (user: string) => {},
  username: '',
  setUsername: (username: string) => {},
  userId: '',
  setUserId: (userId: string) => {},
  roles: Roles,
  userRoles: [] as string[],
  setUserRoles: (userRoles: string[]) => {},
  userConfig: {} as UserConfig,
  setUserConfig: (userConfig: UserConfig) => {},
  onlineMode: true,
  setOnlineMode: (online: boolean) => {},
  notificationCount: 0,
  setNotificationCount: (count: number) => {}
});

export default AuthContext;